import React, { createContext, useContext, useState } from 'react';

interface FormAutoCollapseContextType {
  isTemporaryDisabled: boolean;
  setTemporaryDisabled: (disabled: boolean) => void;
}

const FormAutoCollapseContext = createContext<FormAutoCollapseContextType | undefined>(undefined);

export const FormAutoCollapseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isTemporaryDisabled, setIsTemporaryDisabled] = useState(false);

  const setTemporaryDisabled = (disabled: boolean) => {
    setIsTemporaryDisabled(disabled);
  };

  return (
    <FormAutoCollapseContext.Provider value={{ isTemporaryDisabled, setTemporaryDisabled }}>
      {children}
    </FormAutoCollapseContext.Provider>
  );
};

export const useFormAutoCollapseControl = () => {
  const context = useContext(FormAutoCollapseContext);
  if (context === undefined) {
    throw new Error('useFormAutoCollapseControl must be used within a FormAutoCollapseProvider');
  }
  return context;
};